import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScatterPlotIcon(props: IconProps) {
    return <Icon {...props} iconKey={"scatter_plot"}/>
}
